import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {IContractorEmployeeRequestDto, ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandParameters} from 'app/services/authentication/connection/iCommandParameters';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class AssignContractorAreaCommand extends IRequestCommand<IAssignContractorAreaResponse, ErrorDetails, IUpdateContractorAreaCommandRequest> {
    override _commandType: CommandRequestType = CommandRequestType.PUT;

  public  setId(contractorid: number, areaid: number, areaidassign) {
    this.urlSections.push('contractorsAreas');
    this.urlSections.push(`${contractorid}`);
    this.urlSections.push('area');
    this.urlSections.push(`${areaid}`);
    this.urlSections.push('assign');
    this.urlSections.push(`${areaidassign}`);
    this.composeUrl();
  }
}

export interface IUpdateContractorAreaCommandRequest extends IContractorEmployeeRequestDto,  ICommandParameters {

}

export interface IAssignContractorAreaResponse extends ICommandResponse {
  id: number;
}
